import React from 'react';
import styled from 'styled-components';
import FlexLayout from 'components/layout/Flex'
import BinaryStatsCard from './BinaryStatsCard';
import LaunchpadButtonCard from './LaunchpadButtonCard';
import COMPLETED_IDOS from './config';

const CompletedIDOs = () => {
  return (
    <Container>
      <LaunchpadButtonCard />
      <StyledFlexLayout>
        {COMPLETED_IDOS.map(ido => {
          return <BinaryStatsCard key={ido.tokenSymbol} idoData={ido} />
        })}
      </StyledFlexLayout>
    </Container>
  )
};

const Container = styled.div`
  max-width: 1300px;
  margin-left: auto;
  margin-right: auto;
`;
const StyledFlexLayout = styled(FlexLayout)`
  justify-content: center;

  @media (min-width: 640px) {
    justify-content: center;
  }

  @media (min-width: 968px) {
    justify-content: space-between;
  }

  & > * {
    max-width: unset;

    @media (min-width: 768px) {
      min-width: 320px;
      max-width: 600px;
      width: 100%;
    }

    @media (min-width: 968px) {
      min-width: 320px;
      max-width: 46%;
      width: 100%;
    }
  }

  & > * {
    @media (min-width: 1400px) {
      width: 100%;
    }
  }
`

export default CompletedIDOs;